import React from "react";
import MenuSection from "./MenuSection";
import MenuItemSeparator from "./MenuItemSeparator";
import MenuItem from "./MenuItem";
import { shallowEqual, useSelector } from "react-redux";

export default function MenuList({ currentUrl, menuConfig, layoutConfig }) {

  const { user } = useSelector(state => ({
    user: state.auth.user,
  }), shallowEqual);

  var rolePermissions = user?.roles.reduce((r, i) => r.concat(i.permissions), []).map(i => i.codename);
  var userPermissions = [...new Set(user?.permissions.map(i => i.codename).concat(rolePermissions))];

  return (
    <>
      {menuConfig.aside.items.map((child, index) => {
        if (userPermissions.indexOf(child.permission) >= 0) {
          return (
            <React.Fragment key={`menuList${index}`}>
              {child.section && <MenuSection item={child} />}
              {child.separator && <MenuItemSeparator item={child} />}
              {child.title && (
                <MenuItem
                  item={child}
                  currentUrl={currentUrl}
                  layoutConfig={layoutConfig}
                  userPermissions={userPermissions}
                />
              )}
            </React.Fragment>
          )
        } else {
          return null
        }
      })}
    </>
  )
}